import(/* webpackMode: "eager", webpackExports: ["Cards"] */ "/var/www/joy-awards-frontend/src/app/[lang]/honorees/components/cards.tsx");
